import { useCallback } from 'react';
import { useBetaSeenStore } from '../stores/beta-seen.store';

export function useBetaSeen(featureKey: string) {
  const seenFeatures = useBetaSeenStore((state) => state.seenFeatures);
  const storeMarkSeen = useBetaSeenStore((state) => state.markSeen);

  const markSeen = useCallback(() => {
    storeMarkSeen(featureKey);
  }, [storeMarkSeen, featureKey]);

  return {
    isSeen: seenFeatures[featureKey] === true,
    markSeen
  };
}
